import { forwardRef } from 'react';
import type { CustomItemComponentProps } from 'virtua';

const VirtuaItem = forwardRef<HTMLDivElement, CustomItemComponentProps>(({ index, style, children }, ref) => (
  <div
    style={style}
    key={index}
    ref={ref}
    className='relative after:content-dummy after:absolute after:inset-x-5 after:bg-base-100 after:h-px after:bottom-0 last:after:h-0'>
    {children}
  </div>
));

VirtuaItem.displayName = 'VirtuaItem';

export default VirtuaItem;
